import { useEffect } from 'react';

const useSyncLocalStorage = (key, data) => {
  useEffect(() => {
    const stringifiedData = JSON.stringify(data);
    localStorage.setItem(key, stringifiedData);
  }, [key, data]);
};

export default useSyncLocalStorage;
